export { default as Banner } from './Banner'
export { default as Popup } from './Popup'

// Documentação: https://eskolare.atlassian.net/wiki/spaces/TECHNOLOGY/pages/396820481/Destaques+Eskolare+Shops
